// extracted by mini-css-extract-plugin
module.exports = {"loading":"profile_loading__Wmmg8"};